"use client";

import { useEffect, useRef } from "react";

import { isRouteFocusSuppressed } from "@/lib/route-focus";
import { usePublicPathname } from "@/lib/public-pathname";

export function RouteFocusReset() {
  const pathname = usePublicPathname();
  const firstRender = useRef(true);
  const sentinelRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    if (isRouteFocusSuppressed()) return;
    const focus = () => sentinelRef.current?.focus({ preventScroll: true });
    focus();
    const raf = requestAnimationFrame(focus);
    return () => cancelAnimationFrame(raf);
  }, [pathname]);

  return <span ref={sentinelRef} tabIndex={-1} className="sr-only" />;
}
